/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon16Light = forwardRef('ArrowDRadiusUpLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.146 2.646a.5.5 0 1 1 .708.708L2.207 7H8.5a6.5 6.5 0 0 1 6.5 6.5.5.5 0 1 1-1 0A5.5 5.5 0 0 0 8.5 8H2.207l3.647 3.646a.5.5 0 0 1-.708.708L1.495 8.702a1.7 1.7 0 0 1 0-2.404l3.651-3.652Z" })));
});
